(function () {
  const drawer = document.querySelector('[data-rhri-cart-drawer]');
  const itemsNode = document.querySelector('[data-rhri-cart-items]');
  const countNodes = document.querySelectorAll('[data-rhri-cart-count]');
  const subtotalNode = document.querySelector('[data-rhri-cart-subtotal]');

  function money(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    refreshCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  async function cartRequest(url, options) {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  async function refreshCart() {
    if (!itemsNode) return;
    const cart = await cartRequest('/cart.js');
    countNodes.forEach((node) => { node.textContent = cart.item_count; });
    if (subtotalNode) subtotalNode.textContent = money(cart.total_price);
    itemsNode.innerHTML = cart.items.length ? cart.items.map((item, index) => `
      <div class="rhri-cart-line" data-line="${index + 1}">
        <img src="${item.image || ''}" alt="${item.product_title}">
        <div>
          <strong>${item.product_title}</strong>
          <div class="rhri-copy">${item.variant_title || ''}</div>
          <div class="rhri-quantity" aria-label="Quantity for ${item.product_title}">
            <button type="button" data-rhri-change="${index + 1}" data-qty="${item.quantity - 1}">-</button>
            <input value="${item.quantity}" readonly>
            <button type="button" data-rhri-change="${index + 1}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
        <div>
          <strong>${money(item.final_line_price)}</strong>
          <button class="rhri-trash" type="button" data-rhri-remove="${index + 1}" aria-label="Remove ${item.product_title}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2m-10 0 1 15h10l1-15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </div>
    `).join('') : '<p class="rhri-copy">Your cart is empty.</p>';
  }

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-rhri-open-cart]');
    const close = event.target.closest('[data-rhri-close-cart]');
    const add = event.target.closest('[data-rhri-add-to-cart]');
    const change = event.target.closest('[data-rhri-change]');
    const remove = event.target.closest('[data-rhri-remove]');

    if (open) openDrawer();
    if (close) closeDrawer();

    if (add) {
      event.preventDefault();
      const form = add.closest('form');
      const data = form ? new FormData(form) : null;
      if (!data) return;
      await cartRequest('/cart/add.js', { method: 'POST', body: data });
      openDrawer();
    }

    if (change || remove) {
      event.preventDefault();
      const line = Number((change || remove).dataset.rhriChange || (change || remove).dataset.rhriRemove);
      const quantity = remove ? 0 : Number(change.dataset.qty);
      await cartRequest('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      refreshCart();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  refreshCart().catch(() => {});
})();
